import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { KeyRound } from 'lucide-react';

/**
 * MFA verification form shown after the first-step login when the account
 * has TOTP enabled. Handles both authenticator codes and 8-char backup codes.
 */
export default function MFACodeForm({ mfaCode, onMfaCodeChange, onSubmit, onBack, loading }) {
  return (
    <form onSubmit={onSubmit} className="space-y-4" data-testid="mfa-form">
      <div className="text-center mb-4">
        <KeyRound className="w-12 h-12 text-slate-400 mx-auto mb-3" />
        <p className="text-sm text-slate-600">
          Enter the 6-digit code from your authenticator app
        </p>
      </div>

      <div>
        <Label htmlFor="mfa_code" className="text-slate-700 text-sm font-medium">
          Authentication Code
        </Label>
        <div className="relative mt-1.5">
          <KeyRound className="absolute left-3 top-2.5 w-4 h-4 text-slate-400" />
          <Input
            id="mfa_code"
            type="text"
            maxLength={6}
            placeholder="000000"
            value={mfaCode}
            onChange={(e) => onMfaCodeChange(e.target.value.replace(/\D/g, ''))}
            className="pl-10 font-mono text-center text-lg tracking-widest"
            required
            autoFocus
            data-testid="input-mfa-code"
          />
        </div>
        <p className="text-xs text-slate-500 mt-2 text-center">
          You can also use a backup code
        </p>
      </div>

      <Button
        type="submit"
        className="w-full bg-slate-900 hover:bg-slate-800 text-white mt-6"
        disabled={loading || mfaCode.length !== 6}
        data-testid="submit-mfa-button"
      >
        {loading ? 'Verifying...' : 'Verify'}
      </Button>

      <Button
        type="button"
        variant="ghost"
        className="w-full"
        onClick={onBack}
      >
        Back to Login
      </Button>
    </form>
  );
}
